import { Box, Card, CardActions, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { memo } from 'react'
import CropFreeIcon from '@mui/icons-material/CropFree';
import SettingsIcon from '@mui/icons-material/Settings';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloudIcon from '@mui/icons-material/Cloud';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import AutorenewIcon from '@mui/icons-material/Autorenew';

// 1.code

// function InverterFullSize({ title, onFullScreen }) {
//     // const { getGridLoadData, getInverterChartData } = useContext(InverterContext)
//     const { palette, breakpoints, spacing } = useTheme()
//     const lgs = useMediaQuery(breakpoints.down('lg'))
//     const styles = {
//         IconStyle: {
//             color: 'primary.main',
//             fontSize: '0.9rem',
//             cursor: 'pointer'
//         }
//     }
//     return (
//         <Box component={Card}>
//             <CardActions sx={{ justifyContent: "space-between" }}>
//                 <Typography variant='body1'>{title}</Typography>
//                 <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
//                     <FullscreenIcon sx={styles.IconStyle} onClick={onFullScreen} color='primary' />
//                     <SettingsIcon sx={styles.IconStyle} />
//                 </Stack >
//             </CardActions>
//         </Box >
//     )
// }

// export default memo(InverterFullSize)


function InverterFullSizeDailyEnergy({ title, onFullScreen, children }) {
    const { palette, breakpoints } = useTheme()
    const lgs = useMediaQuery(breakpoints.down('lg'))

    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '0.9rem',
            cursor: 'pointer'
        }
    }

    return (
        <Box component={Card}>
            <CardActions sx={{ justifyContent: "space-between" }}>
                <Typography variant='body1'>{title}</Typography>
                <Stack direction={'row'} alignItems={'center'}>
                    <FullscreenIcon sx={styles.IconStyle} onClick={onFullScreen} />
                    <SettingsIcon sx={styles.IconStyle} />
                </Stack>
            </CardActions>

            {/* 👇 Add this to show children (radio buttons + content) */}
            <Box p={0}>
                {children}
            </Box>
        </Box>
    )
}

export default memo(InverterFullSizeDailyEnergy)
